import mapValuesLodash from "lodash/mapValues"
import mapKeysLodash from "lodash/mapKeys"
import IFlowConfig from "./IFlowConfig"
import { PropType } from "vue"

export const mapValues = mapValuesLodash
export const mapKeys = mapKeysLodash

export const isObject = (value: unknown): value is object =>
  typeof value === "object" && !Array.isArray(value) && value !== null

export const wrapInCurly = (text: string) => "${" + text + "}"

export type TFunction = (...args: any[]) => any

export type KeysToValues<T> = {
  [Properties in keyof T]: Properties
}

export interface IGlobalGetter {
  empty?: TFunction
  getter: TFunction
}

export type IFlowDataAccessConfigGetters = Record<
  string,
  Record<string, IGlobalGetter>
>
export type IFlowDataAccessConfigActions = Record<
  string,
  Record<string, TFunction>
>

export interface IFlowDataAccessConfig {
  getters: IFlowDataAccessConfigGetters
  actions: IFlowDataAccessConfigActions
}

export interface IFlowConfigInput {
  type: PropType<unknown>
  empty?: TFunction
}

export type FlowConfigGetters = Record<string, TFunction>
export type FlowConfigInputTypes = Record<string, IFlowConfigInput>

export const mapKeysToValues = <T extends object>(object: T) =>
  mapValues(object, (value, key) => key) as KeysToValues<T>

export const defineFlowConfig = <
  TGetters extends FlowConfigGetters,
  TInputs extends FlowConfigInputTypes,
>(
  config: IFlowConfig<TGetters, TInputs>,
): IFlowConfig<TGetters, TInputs> => config

export const defineDataAccessConfig = <T extends IFlowDataAccessConfig>(
  config: T,
) => config

export type FunctionMap = Record<string, TFunction>

export const booleanArrayValues = ["true", "false"]
